<template>
  <div class="block">
    <div class="block__header">
      <h2 class="block__title__slim">{{content.ItemName}}</h2>
      <div class="block__tools__slim">
        <select class="select" v-model="item.DealerLogoFile" v-if="content.DealerLogoFiles">
          <option :value="logo.Value" v-for="logo in content.DealerLogoFiles">{{logo.Text}}</option>
        </select>
        <select class="select" v-model="item.PdfSettings" v-if="content.AvailableResolutions">
          <option :value="resolution.Value" v-for="resolution in content.AvailableResolutions">{{resolution.Text}}</option>
        </select>
        <button class="icon-button document__actions__button basket-green" @click="basketBrochure(item)"></button>
        <button class="icon-button document__actions__button download-green" @click="downloadBrochure(item)"></button>
        <button class="icon-button document__actions__button mail-green" @click="mailBrochure(item)" :disabled="mailSending"></button>
      </div>
    </div>
    <div class="block__content">
      <div class="brochures">
        <ul class="brochure-list">
          <li class="brochure-list__item" v-for="page in content.GeneratedThumbnails" track-by="$index"><img :src="page"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { basketBrochure, mailBrochure, downloadBrochure } from "./DocumentsActions";
  export default {
    props: ["content"],
    data: function () {
      return {
        item: {
          Id: 0,
          CategoryId: 0,
          PdfSettings: 72,
          DealerLogoFile: ""
        }
      };
    },
    ready: function () {
      this.item.Id = this.content.ItemId;
      this.item.PdfSettings = (this.content.AvailableResolutions && this.content.AvailableResolutions.length > 0) ? this.content.AvailableResolutions[0].Value : "";
      this.item.CategoryId = this.content.CategoryId;
      this.item.BrochureType = this.content.BrochureType;
    },
    vuex: {
      actions: { basketBrochure, mailBrochure, downloadBrochure },
      getters: {
        mailSending: state => state.mailSending
      }
    },
    watch: {
      "content.ItemId": function (value) {
        this.item.Id = this.content.ItemId;
        this.item.PdfSettings = (this.content.AvailableResolutions && this.content.AvailableResolutions.length > 0) ? this.content.AvailableResolutions[0].Value : "";
        this.item.CategoryId = this.content.CategoryId;
        this.item.BrochureType = this.content.BrochureType;
      },
      "content.BrochureType": function (value) {
        this.item.Id = this.content.ItemId;
        this.item.PdfSettings = (this.content.AvailableResolutions && this.content.AvailableResolutions.length > 0) ? this.content.AvailableResolutions[0].Value : "";
        this.item.CategoryId = this.content.CategoryId;
        this.item.BrochureType = this.content.BrochureType;
      }
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .brochures{
    padding-bottom: 40px;
  }

  .brochure-list{
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-x: scroll;
    white-space: nowrap;
    padding-bottom: 40px;

    &__item{
      display: inline-block;
      margin-right: 20px;

      &:last-child{
        margin-right: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// DocumentsBrochure.vue?27346c36